// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"19a5df9e","99":"a6438922","197":"aa713dfc","706":"180085ca","766":"545b4f86","798":"3b5abc15"}[chunkId] + ".chunk.js";
};